<template>
    <v-dialog
        :fullscreen="isMobile" v-model="dialog" max-width="700"
        :transition="isMobile ? 'dialog-bottom-transition' : 'dialog-transition'"
        @click:outside="hide"
    >
        <v-card tile>
            <v-app-bar color="white" flat>
                <v-row align="center">
                    <v-col cols="2"/>
                    <v-col cols="8" class="app-title">
                        {{ $t('common.upload_links') }}
                    </v-col>
                    <v-col cols="2" align="right">
                        <v-btn icon @click="hide">
                            <v-icon color="black">$close</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-app-bar>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <small>{{ $t('common.upload_links_subtitle') }}</small>
                        <br>
                        <small v-html="$t('common.upload_links_help')"/>
                    </v-col>
                </v-row>
                <v-row v-for="(link, i) in links" :key="i" align="center">
                    <v-col cols="5" md="6">
                        <kimsa-text-field
                            :label="`${$t('common.name')} ${i+1}`"
                            :placeholder="$t('common.write_here')"
                            bolder-label
                            outlined dense
                            :value="link.name"
                            @change="link.name = $event"
                        />
                    </v-col>
                    <v-col cols="5" md="5">
                        <kimsa-text-field
                            :label="`${$t('common.link')} ${i+1}`"
                            :placeholder="$t('common.write_here')"
                            bolder-label
                            outlined dense
                            @blur="link.videoId = getYouTubeVideoId(link.videoId)"
                            :value="link.videoId"
                            @change="link.videoId = $event"
                        />
                    </v-col>
                    <v-col cols="2" md="1">
                        <div class="label bolder">
                            {{ $t('common.see') }}
                        </div>
                        <v-btn icon color="#fd0000" :disabled="!link.videoId" @click="goToVideo(link.videoId)">
                            <v-icon>mdi-youtube</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="border-actions">
                <v-spacer></v-spacer>
                <v-btn @click="hide" depressed class="normal-btn">
                    {{ $t('common.cancel') }}
                </v-btn>
                <v-btn color="primary" class="black--text normal-btn" @click="save" :loading="loading" depressed>
                    {{ $t('common.save') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import {mapMutations, mapState} from 'vuex'
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import {db} from "@/utils/Firebase";

export default {
    name: "YoutubeUploadLinksDialog",
    components: {KimsaTextField},
    data(vm) {
        return {
            dialog: false,
            loading: false,
            linksTemplate: [
                {name: '', videoId: ''},
                {name: '', videoId: ''},
                {name: '', videoId: ''},
            ],
            links: [
                {name: '', videoId: ''},
                {name: '', videoId: ''},
                {name: '', videoId: ''},
            ],
        }
    },
    computed: {
        ...mapState(['dialogActive'])
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        show() {
            const vm = this
            vm.setDefaults()
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
            vm.reset()
        },
        reset() {
            const vm = this
            vm.links = vm.linksTemplate
        },
        getYouTubeVideoId(url) {
            const pattern = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
            const match = url.match(pattern)
            return match?.[1] ? match[1] : null
        },
        setDefaults() {
            const vm = this
            if (!vm.account?.links || vm.account?.links?.length === 0) return;
            if (vm.account?.links) {
                let links = []
                for (let i = 0; i < 3; i++)
                    vm.account.links[i] ? links.push(vm.account.links[i]) : links.push({name: '', videoId: ''})
                vm.links = links
            } else {
                vm.links = vm.linksTemplate
            }
        },
        goToVideo(videoId) {
            const vm = this
            window.open('https://www.youtube.com/watch?v=' + videoId, '_blank')
        },
        async save() {
            const vm = this
            vm.loading = true

            await db.collection('users').doc(vm.currentUser.uid).update({
                links: vm.links.filter(link => !!link.name && !!link.videoId)
            })

            vm.toast(vm.$t('common.links_saved'))
            vm.loading = false
            vm.hide()
        }
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
    }
}

</script>

<style scoped>

.app-title {
    color: #333333;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
}

.label {
    font-size: 15px;
    color: #333333;
}

</style>